import { IState } from 'types/redux'

export const getWorkspace = ({ workspace }: IState): any => workspace

export const getWorkspaceActiveId = ({ workspace }: IState): any => workspace.activeId

export const getCurrentWorkspace = ({ workspace }: IState): any => workspace.data?.find(el => el.id === workspace.activeId)
